import moment from 'moment';

export const createQuestion = (date, data, title) => ({
  title: {
    text: title,
    left: 'center',
  },
  grid: {
    right: 50,
    left: 50,
  },
  tooltip: {
    trigger: 'axis',
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: date.map(x => moment(x).format('M/DD')),
  },
  yAxis: {
    type: 'value',
    boundaryGap: [0, '100%'],
  },
  series: [
    {
      name: '新增问题总数',
      type: 'line',
      symbol: 'none',
      sampling: 'average',
      data,
    },
  ],
});

export const ask = (date, askTime, hitTime, missTime, title) => ({
  title: {
    text: title,
    left: 'center',
  },
  grid: {
    right: 50,
    left: 50,
  },
  legend: {
    data: ['提问次数', '已知问题提问数', '未知问题提问数'],
    bottom: 0,
  },
  tooltip: {
    trigger: 'axis',
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: date.map(x => moment(x).format('M/DD')),
  },
  yAxis: {
    type: 'value',
    boundaryGap: [0, '100%'],
  },
  series: [
    {
      name: '提问次数',
      type: 'line',
      symbol: 'none',
      sampling: 'average',
      data: askTime,
    },
    {
      name: '已知问题提问数',
      type: 'line',
      symbol: 'none',
      sampling: 'average',
      data: hitTime,
    },
    {
      name: '未知问题提问数',
      type: 'line',
      symbol: 'none',
      sampling: 'average',
      data: missTime,
    },
  ],
});

export const love = (date, upTime, downTime, title) => ({
  title: {
    text: title,
    left: 'center',
  },
  grid: {
    right: 50,
    left: 50,
  },
  legend: {
    data: ['点赞次数', '点踩次数'],
    bottom: 0,
  },
  tooltip: {
    trigger: 'axis',
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: date.map(x => moment(x).format('M/DD')),
  },
  yAxis: {
    type: 'value',
    boundaryGap: [0, '100%'],
  },
  series: [
    {
      name: '点赞次数',
      type: 'line',
      symbol: 'none',
      sampling: 'average',
      data: upTime,
    },
    {
      name: '点踩次数',
      type: 'line',
      symbol: 'none',
      sampling: 'average',
      data: downTime,
    },
  ],
});
